// extracted by mini-css-extract-plugin
module.exports = {"top":"Social_top__1khjx","icon":"Social_icon__1LlGz"};